<template>
<v-layout column>
	<div>
		<div class="table">
			<div class="header">
				<div class="header__item" v-for="header in headers">
					{{header.text}}
				</div>
			</div>
			<div>
				<div v-if="!onlyMultiple">
					<div class="group-address">{{mainLabel}}</div>
					<div class="content" v-if="mainAddress">
						<div class="content__row">
							<Row :address="mainAddress"></Row>
							<div class="row__item action">
								<v-tooltip top>
									<v-btn slot="activator" fab dark small color="indigo lighten-2" @click="edit(mainAddress)">
										<v-icon dark>edit</v-icon>
									</v-btn>
									<span>{{$t('common.edit')}}</span>
								</v-tooltip>

								<ConfirmDialog
									v-if="!hideDelete"
									v-bind="propConfirmDialog"
									@accept="onDelete(mainAddress)"
									:tooltip="$t('common.delete')"
								>
									<v-icon dark>delete</v-icon>
								</ConfirmDialog>
							</div>
						</div>
					</div>
					<div v-else>
						<v-tooltip top>
							<v-btn slot="activator" @click="openOne" small dark fab color="red lighten-1">
								<v-icon>add</v-icon>
							</v-btn>
							<span>
								{{$t('address.add_address')}}
							</span>
						</v-tooltip>
					</div>
				</div>
			</div>
			<div class="group-address" v-if="!onlyMultiple">{{listLabel}}</div>
			<div class="content__row" v-for="address in listAddress">
				<Row :address="address"></Row>
				<div class="row__item action">
					<v-tooltip top>
						<v-btn slot="activator" fab dark small color="indigo lighten-2" @click="edit(address)">
							<v-icon dark>edit</v-icon>
						</v-btn>
						<span>{{$t('common.edit')}}</span>
					</v-tooltip>

					<ConfirmDialog v-bind="propConfirmDialog" @accept="onDelete(address)" :tooltip="$t('common.delete')">
						<v-icon dark>delete</v-icon>
					</ConfirmDialog>
				</div>
			</div>
		</div>
	</div>
	<form-address :onlyMain="onlyMain" v-bind="propForm" @open="open" @cancel="cancel" @save="save"></form-address>
</v-layout>
</template>
<script>
import { HEADERS_TABLE_ADDRESS, TEMPLATE_ADDRESS } from '../../constants'
import Row from './Row'
import FormAddress from './FormAddress'
import ConfirmDialog from '../../components/ConfirmDialog'
import {localeHeadersAddress} from "../../utils/helpers";

export default {
	components: {
		Row,
		FormAddress,
		ConfirmDialog
	},
	props: {
		mainAddress: Object,
		listAddress: Array,
		mainLabel: String,
		listLabel: String,
		onlyMain: {
			type: Boolean,
			default: false
		},
		onlyMultiple: {
			type: Boolean,
			default: false
		},
		hideDelete: {
			type: Boolean,
			default: false
		}
	},
	data: (vm) => ({
		propForm: {
			addressData: { ...TEMPLATE_ADDRESS },
			dialog: false
		},
		propConfirmDialog: {
			message: vm.$t('address.confirm_address'),
			title: vm.$t('common.confirm'),
			btnProps: {
				fab: true,
				dark: true,
				small: true,
				color: 'red lighten-2'
			}
		},
		headers: localeHeadersAddress(HEADERS_TABLE_ADDRESS, vm.$t)
	}),
	methods: {
		cancel() {
			this.propForm.dialog = false
			this.propForm.addressData = { ...TEMPLATE_ADDRESS }
		},
		open(clean = true) {
			clean ? this.propForm.addressData = { ...TEMPLATE_ADDRESS } : ''
			this.propForm.dialog = true
		},
		save(data) {
			let funcName = 'update'
			if (data.id === 0) {
				funcName = 'createMultiple'
			}
			if (data.id === -1) {
				funcName = 'createOne'
			}
			this.$emit(funcName, data)

			this.cancel()
		},
		edit(data) {
			this.setDataForm(data)
			this.open(false)
		},
		onDelete(address) {
			this.$emit('delete', address.id)
		},
		openOne() {
			this.propForm.addressData = { ...TEMPLATE_ADDRESS, id: -1 }
			this.open(false)
		},
		setDataForm(data) {
			this.propForm.addressData = { ...data }
		}
	}
}
</script>
<style scoped>
	.table {
		display: flex;
		flex-direction: column;
		justify-content: space-around;
	}
	.header {
		display: flex;
		height: 30px;
		flex-direction: row;
		border-bottom: 2px solid #dedede;
	}
	.header__item {
		height: 20px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.content {
		display: flex;
		flex-direction: column;
	}
	.content__row {
		display: flex;
		flex-direction: row;
		border-bottom: 1px solid #dedede;
		align-items: center;
		min-height: 50px;
	}
	.header__item,
	.row__item {
		width: 8vw;
	}
	.group-address {
		text-align: center;
		font-weight: bold;
		margin-top: 5px;
		border-bottom: 1px solid #dedede;
	}
	.action {
		display: flex;
		flex-direction: row;
	}
</style>
